<template>
  <div class="row">
    <div class="col-sm-12">
      <b-card hide-header="true" title="Contact Us" class="white">
        <p class="card-text">
          <contact-form/>
        </p>
      </b-card>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-title{
  font-size: 1.25rem;
  margin-left: 15px;
  margin-bottom: 1rem;
}
</style>

<script>
  import ContactForm from '../../components/ContactForm';
  export default {
    components: {
      ContactForm
    },
    data () {
      return {
        tickets: []
      };
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Help/ContactSupport.vue